import React, { Component } from 'react';
import './styles.css';
import { handleKeySubmit } from '../../utilities/userUtil';

export default class OptionButton extends Component {

  render() {
    const { isSelected, onClick, className } = this.props;
    return (
      <div
        className={`option__button ${className} ${isSelected ? 'option__button--selected' : ''}`}
        onClick={onClick}
        onKeyDown={(event) => handleKeySubmit(event.keyCode, onClick)}
        tabIndex="0">
        <div className="option__inner">
          {this.props.children}
        </div>
      </div>
    )
  }


};



// WEBPACK FOOTER //
// ./src/components/OptionButton/OptionButton.js